import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client/react'
import apolloClient from '@graphql/apollo-client'
import App from './App'
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev'

const container = document.getElementById('root')
const root = createRoot(container)

const render = () => {
  root.render(
    <StrictMode>
      <BrowserRouter future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}>
        <ApolloProvider client={apolloClient}>
          <App />
        </ApolloProvider>
      </BrowserRouter>
    </StrictMode>
  )
}

render()

if (process.env.NODE_ENV === 'development' && typeof module !== 'undefined' && module.hot) {
  module.hot.accept('./App', render)
  loadDevMessages()
  loadErrorMessages()
}
